import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Pages numérotées (fenêtre ±2 autour de la page courante, première/dernière toujours visibles).
export const pageWindow = (page, pages) => {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const set = new Set([1, pages, page - 2, page - 1, page, page + 1, page + 2].filter((p) => p >= 1 && p <= pages));
  const sorted = [...set].sort((a, b) => a - b);
  const out = [];
  sorted.forEach((p, i) => { if (i && p - sorted[i - 1] > 1) out.push("…"); out.push(p); });
  return out;
};

export const AdminPager = ({ page, pages, onPage, testId = "pager" }) => {
  if (!pages || pages <= 1) return null;
  const go = (p) => { if (p >= 1 && p <= pages && p !== page) onPage(p); };
  return (
    <nav className="flex items-center justify-center gap-1 flex-wrap" aria-label="Pagination" data-testid={testId}>
      <button type="button" className="pill pill-outline text-xs px-2.5 disabled:opacity-40" disabled={page <= 1} onClick={() => go(page - 1)} data-testid={`${testId}-prev`} aria-label="Page précédente">
        <ChevronLeft size={14} />
      </button>
      {pageWindow(page, pages).map((p, i) => (p === "…"
        ? <span key={`e${i}`} className="px-1 text-xs" style={{ color: "var(--yalola-text-muted)" }}>…</span>
        : <button key={p} type="button" className={`pill text-xs px-3 ${p === page ? "pill-primary" : "pill-outline"}`} aria-current={p === page ? "page" : undefined} onClick={() => go(p)} data-testid={`${testId}-page-${p}`}>{p}</button>
      ))}
      <button type="button" className="pill pill-outline text-xs px-2.5 disabled:opacity-40" disabled={page >= pages} onClick={() => go(page + 1)} data-testid={`${testId}-next`} aria-label="Page suivante">
        <ChevronRight size={14} />
      </button>
    </nav>
  );
};
